module.exports = __webpack_public_path__ + "static/media/22a.2b6706aa.jpg";